<template>
  <form class="d-grid" @submit.prevent="submit">
    <shifts-field :initial-selected-shift-ids="initialSelectedShiftIds" :shifts="event.shifts"
                  :show-days-for-shifts="showDaysForShifts" @changed="updateSelectedShiftIds" />

    <submit-button :label="submitButtonLabel" @click="submit" />
  </form>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import ShiftsField from './shifts-field'
import SubmitButton from '@/components/buttons/submit-button'

export default {
  components: { ShiftsField, SubmitButton },

  props: {
    initialSelectedShiftIds: {
      type: Array,
      required: true
    },

    submitButtonLabel: {
      type: String,
      required: true
    }
  },

  emits: ['submit'],

  data() {
    return {
      selectedShiftIds: this.initialSelectedShiftIds
    }
  },

  computed: {
    ...mapState(['event']),
    ...mapGetters(['shiftsByDay']),

    showDaysForShifts() {
      return Object.keys(this.shiftsByDay).length > 1
    }
  },

  methods: {
    submit() {
      this.$emit('submit', this.selectedShiftIds)
    },

    updateSelectedShiftIds(newValue) {
      this.selectedShiftIds = newValue
    }
  }
}
</script>
